export default {
  pathPrefix: '/', // Prefix for all links. If deploy your site to example.com/portfolio your pathPrefix should be "portfolio"

  siteTitle: 'SmartSolar', // Navigation and Site Title
  siteTitleAlt: 'Det trygga och framtidssäkra valet för övervakning av solcelssanläggningar', // Alternative Site title for SEO
  siteUrl: 'https://typescript-power-blog.github.com', // Domain of your site. No trailing slash!
  siteLanguage: 'sv', // Language Tag on <html> element
  siteBanner: '/assets/banner.jpg', // Your image for og:image tag. You can find it in the /static folder
  defaultBg: '/assets/bg.jpg', // default post background header
  favicon: 'src/favicon.png', // Your image for favicons. You can find it in the /src folder
  siteDescription: 'Det trygga och framtidssäkra valet för övervakning av solcelssanläggningar', // Your site description
  author: 'Thomas Selig', // Author for schemaORGJSONLD
  siteLogo: '/assets/modio_green.png', // Image for schemaORGJSONLD
  siteLogoInv: '/assets/modio_green_inverted.png',
  siteMenu: [
    {
      name:'Start',
      link:'/',
      icon:'/assets/home_logo.svg'
    },
    {
      name:'För installatörer',
      link:'/installatorer',
      icon:''
    },
    {
      name:'Specifikationer',
      link:'/specifikationer',
      icon:''
    },
  ],

  // siteFBAppID: '', // Facebook App ID - Optional
  userTwitter: '', // Twitter Username - Optional
  ogSiteName: '', // Facebook Site Name - Optional
  ogLanguage: '', // Facebook Language

  // Manifest and Progress color
  // See: https://developers.google.com/web/fundamentals/web-app-manifest/
  themeColor: '#b1cc3b',
  backgroundColor: '#2a3a42',

  // Settings for typography.ts
  headerFontFamily: 'Arvo',
  bodyFontFamily: 'Open Sans',
  baseFontSize: '18px',

  // Social media
  siteFBAppID: '',

  //
  Google_Tag_Manager_ID: '',
  POST_PER_PAGE: 4,
};
